import { BaseManager, BaseListManager } from "./index.js";
import { PlatformService } from "@/modules/api.js";

export class LineupManager extends BaseManager {
  _ServiceClass = PlatformService;

  dataProps = {
    bench: "object",
    congress: "object",
    created: "string",
    id: "number",
    misc: "object",
    points: "number",
    team: "number",
    updated: "string",
    week_end: "string",
    week_number: "number",
    week_start: "string"
  };
}

export class LineupListManager extends BaseListManager {
  _InstanceClass = LineupManager;
  _ServiceClass = PlatformService;

  get(leagueId, teamId, limit, offset) {
    const path = `/api/leagues/${leagueId}/teams/${teamId}/lineups/?limit=${limit}&offset=${offset}`;
    return this._get(path);
  }
}
